import { FadeInLayersCommand, FadeOutLayersCommand } from "commands/fade-layers-command";
import Layers from "slotworks/graphics/layers/layers";
import { parallel, sequence } from "slotworks/utils/race-utils";
import HarleyComponents from "components/components";
import Contract from "slotworks/utils/contract";
import { HideBaseLayers } from "commands/base-layers-commands";

export default class FreespinsIntroComponent {

    constructor() {

    }

    public show() {
        return sequence([
            () => Layers.BonusForeground.setScene("freespinswin"),
            () => Layers.Bonus.setScene("freespinswin1"),
            () => HarleyComponents.freespinsWheelSpins.createWheel(),
            () => Contract.wrap(() => {
                Layers.Bonus.hide();
                Layers.BonusForeground.hide();
            }),
        ]);
    }

    public start() {
        return sequence([
            () => Contract.getTimeoutContract(300),
            () => Contract.wrap(() => HideBaseLayers()),
            () => Layers.Background.setScene("bonus"),
            () => Layers.BonusForeground.setScene("freespinswin"),
            () => Layers.Bonus.setScene("freespinswin1"),
            () => HarleyComponents.freespinsWheelSpins.createWheel(),
            () => Contract.wrap(() => {                
                HarleyComponents.harley.show(true);
                HarleyComponents.harley.showIdleFreespins();
                HarleyComponents.background.startBonus();
            }),
            () => Contract.getTimeoutContract(100),
            () => HarleyComponents.freespinsWheelSpins.start(),
            () => HarleyComponents.freespinsWheelBoosters.createWheel(),
            () => parallel([
                () => HarleyComponents.freespinsWheelSpins.complete(),
                () => HarleyComponents.freespinsWheelBoosters.start(),
            ]),
            () => Layers.BonusForeground.defaultScene(),
            () => Layers.Bonus.defaultScene(),
        ]);
    }

    public recover() {
        return sequence([
            () => Layers.BonusForeground.setScene("freespinswin"),
            () => Layers.Bonus.setScene("freespinswin1"),
            () => HarleyComponents.freespinsWheelSpins.createWheel(),
            () => Layers.Background.setScene("bonus"),
            () => parallel([
                () => FadeInLayersCommand([
                    Layers.Bonus,
                    Layers.BonusForeground,
                ], 400),
                () => Contract.wrap(() => {
                    HarleyComponents.harley.show(false, 600);
                    HarleyComponents.background.startBonus();
                }),
                () => HarleyComponents.freespinsWheelSpins.start(),
            ]),
            () => HarleyComponents.freespinsWheelBoosters.createWheel(),
            () => parallel([
                () => HarleyComponents.freespinsWheelSpins.complete(),
                () => HarleyComponents.freespinsWheelBoosters.start(),
            ]),
            () => Layers.BonusForeground.defaultScene(),
            () => Layers.Bonus.defaultScene(),
        ]);
    }
}